import React from "react";
import ShopPromotionForm from "./ShopPromotionForm";

const EditShopPromotion = (props) => <ShopPromotionForm promotionId={props.match.params.id} />;

export default EditShopPromotion;
